import React from 'react';
import { RegionUbk } from 'api/get-app-init-details';
import { CASE_MANAGEMENT_COHORT_TYPE } from 'common/constants';

export interface RegionSelection {
  selectedRegion: RegionUbk | undefined;
  regionOptions?: RegionUbk[] | undefined;
}

export const RegionSelectionContext = React.createContext<RegionSelection>({
  selectedRegion: {
    brandUbk: undefined,
    clientNumber: undefined,
    groupNumber: undefined,
    planName: undefined,
    planType: undefined,
  },
  regionOptions: undefined,
});

export interface CareManagementCohort {
  cohortType: CASE_MANAGEMENT_COHORT_TYPE | undefined;
  eligible: boolean;
}
